import React from 'react';

import noop from 'lodash/noop';

import * as S from './style';

type TValue = any;

type TProps = {
  as?: keyof JSX.IntrinsicElements | TAnyComponent;
  className?: string;
  value?: TValue;
  label?: React.ReactNode;
  onClick?: (value: TValue, event?: React.MouseEvent) => void;
  selected?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  isFocus?: boolean;
  isCurrent?: boolean;
  innerRef?: React.RefObject<HTMLElement>;
  // Link
  href?: string;
  to?: string;
  rel?: string;
  target?: string;
  hoverDisabledStyle?: boolean;
};

export type TOptionProps = TProps;

const Option = React.memo<TProps>(
  ({
    className,
    value,
    label = value,
    onClick = noop,
    disabled,
    readOnly,
    selected,
    isCurrent,
    innerRef,
    hoverDisabledStyle,
    ...other
  }) => {
    const handleClick = React.useCallback(
      (event: React.MouseEvent) => {
        if (value === undefined) {
          return;
        }

        onClick(value, event);
      },
      [onClick, value],
    );

    return (
      <S.Option
        {...other}
        className={className}
        onClick={disabled || disabled ? undefined : handleClick}
        disabled={disabled}
        readOnly={readOnly}
        selected={selected}
        isCurrent={isCurrent}
        ref={innerRef}
        hoverDisabledStyle={hoverDisabledStyle}
      >
        {label}
      </S.Option>
    );
  },
);

export default Option;
